import PaymentView from './PaymentView';
export default PaymentView;
